import { useContext } from 'react';
import { Grid, AppConstants } from '@ltvco/refresh-lib';
import { StyledLink } from './components';

const REWARDS_LINK = '/dashboard/rewards';
const SAMPLE_REPORT_LINK = 'https://www.bumper.com/sample-report';
const CUSTOM_PLAN_LINK =
  'mailto:business@bumper.com?subject=Custom%20Plan%20Request';

export function AboutUsLinks() {
  const {
    links: { aboutLink, brandIosUrl, brandAndroidUrl, blogLink },
  } = useContext(AppConstants);

  return (
    <>
      <Grid item xs={12} sm={3}>
        <StyledLink to={aboutLink} target="_blank">
          About Bumper
        </StyledLink>
      </Grid>
      <Grid item xs={12} sm={3}>
        <StyledLink to={REWARDS_LINK} target="_blank">
          Rewards
        </StyledLink>
      </Grid>
      <Grid item xs={12} sm={3}>
        <StyledLink to={brandIosUrl || ''} target="_blank">
          iOS App
        </StyledLink>
      </Grid>
      <Grid item xs={12} sm={3}>
        <StyledLink to={brandAndroidUrl || ''} target="_blank">
          Android App
        </StyledLink>
      </Grid>
      <Grid item xs={12} sm={3}>
        <StyledLink to={blogLink} target="_blank">
          Blog
        </StyledLink>
      </Grid>
      <Grid item xs={12} sm={3}>
        <StyledLink to={SAMPLE_REPORT_LINK} target="_blank">
          Sample Report
        </StyledLink>
      </Grid>
      <Grid item xs={12} sm={3}>
        <StyledLink to={CUSTOM_PLAN_LINK} target="_blank">
          Request Custom Plan
        </StyledLink>
      </Grid>
    </>
  );
}
